import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCircleIconButton,
  StyledCircleIconButtonIcon,
} from './StyledCircleIconButton';

const CircleIconButton = ({ children, icon, ...rest}) => (
  <StyledCircleIconButton type='text' {...rest}>
    <StyledCircleIconButtonIcon>
      {icon}
    </StyledCircleIconButtonIcon>
    {children}
  </StyledCircleIconButton>
);

CircleIconButton.propTypes = {
  icon: PropTypes.any,
}

export default CircleIconButton;
